export const FETCH_DAILY_RELEASED_TESTS_REQUEST  = "FETCH_DAILY_RELEASED_TESTS_REQUEST";
export const FETCH_DAILY_RELEASED_TESTS_SUCCESS  = "FETCH_DAILY_RELEASED_TESTS_SUCCESS";
export const FETCH_DAILY_RELEASED_TESTS_FAILURE  = "FETCH_DAILY_RELEASED_TESTS_FAILURE";